module.exports = {
    MULTIPLE_QUOTA_TAG: "hasta 36 meses",
    MULTIPLE_QUOTA: "multiple",
    ONE_QUOTA_TAG: "1 mes despues",
    ONE_QUOTA: "one",
    THREE_QUOTA_TAG: "3 meses",
    THREE_QUOTA: "three",
    PAY_LATER: "pago_facil_paga_despues",
    NOMINAL: "nominal",
    TAE: "tae",
    TIN: "tin",
    PACK_KEY: "lavanda-lavanda_legalNotesPack",
    NO_PACK_KEY: "lavanda-lavanda_legalNotesNotPack",
};